export enum OfficeCountry {
  SK = 'SK',
  CZ = 'CZ',
  UK = 'UK',
  US = 'US',
  AU = 'AU',
  CA = 'CA',
}

type OfficeAddressType = {
  street: string
  city: string
}

const officeLocations: Partial<Record<OfficeCountry, OfficeAddressType>> = {
  [OfficeCountry.CA]: {
    street: 'office-location-ca-address-0',
    city: 'office-location-ca-address-1',
  },
  [OfficeCountry.US]: {
    street: 'office-location-us-address-0',
    city: 'office-location-us-address-1',
  },
  [OfficeCountry.UK]: {
    street: 'office-location-uk-address-0',
    city: 'office-location-uk-address-1',
  },
  [OfficeCountry.SK]: {
    street: 'office-location-sk-address-0',
    city: 'office-location-sk-address-1',
  },
  [OfficeCountry.AU]: {
    street: 'office-location-au-address-0',
    city: 'office-location-au-address-1',
  },
}

export const useOfficeLocationsContent = () => ({
  title: 'office-locations-title',
  offices: officeLocations,
  ofText: 'of-text',
  previousAriaLabel: 'office-location-previous-aria-label',
  nextAriaLabel: 'office-location-next-aria-label',
  pointAriaLabel: 'office-location-point-aria-label',
})
